import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import { getTemplateDetail, updateTemplateDetail } from "../../../../utils/facebookLikeButtonApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import BlankTemplateWidget from "../../../../components/Apps/FacebookLikeButton/Template/BlankTemplateWidget";

//Import Tabs
import SourceTab from "../../../../components/Apps/FacebookLikeButton/SourceTab";
import LayoutTab from "../../../../components/Apps/FacebookLikeButton/LayoutTab";

export default function EditFacebookLikeButton() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeSection, setActiveSection] = useState("Source");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Blank_Temp");
    const [selectedLayout, setSelectedLayout] = useState("blank_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("blank.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Facebook Like Button");
    const [newWidgetName, setNewWidgetName] = useState("");
    const { uuid } = useParams();
    const [isTemplateId, setIsTemplateId] = useState(null);

    const [facebookLikeButtonTabData, setFacebookLikeButtonTabData] = useState({
        is_website_frontend: "",  
        source_type: "Current Page",     
        custom_url: "",     
        type: "Like",  
        width: "450px",  
        layout_type: "Standard",  
        size_type: "small",  
        is_show_friends: 1,   
        is_show_share: 1,     
        custom_css: "",   
        custom_js: "",   
    });

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateFacebookLikeButtonTabData = (key, value) => {
        setFacebookLikeButtonTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const menuItems = [
      { key: "Source", icon: "source.png", label: "Source" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
    ];

    // Fetching Tempate data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getTemplateDetail(uuid);

                //check if result is exist
                if (templateResult.data) {
                    setIsTemplateId(templateResult.data.uuid);
                    setWidgetName(templateResult.data.name);
                    setActiveTemplateSection(templateResult.data.template_name);
                    setSelectedLayout(templateResult.data.layout_type);
                    setSelectedTemplateImage(templateResult.data.template_image);
                    // Convert settings array to object
                    const settingsObject = templateResult.data.settings.reduce((acc, setting) => {
                        acc[setting.setting_key] = setting.setting_value;
                        return acc;
                    }, {});

                    setFacebookLikeButtonTabData(settingsObject); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        
        fetchData();
    }, [uuid, setFacebookLikeButtonTabData]);
  
    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const extractedImageName = selectedTemplateImage.split('/').pop();

            // Convert settings object back into an array of key-value pairs
            const settingsArray = Object.entries(facebookLikeButtonTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: extractedImageName,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/facebook-like-button');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
        <div className="create-goole-reviews-all">
            <div className="overlay-side-baar">
                <div className="side-baar-inner-one">
                    <ul>
                        {menuItems.map((item) => (
                            <li key={item.key}>
                                <button
                                    className={activeSection === item.key ? "active" : ""}
                                    onClick={() => setActiveSection(item.key)}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/facebook-like-button/icons/${item.icon}`}
                                        alt={`${item.key} icon`}
                                    />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="side-baar-inner-tow">
                    {/* Conditional Rendering for Sections */}
                    {activeSection === "Source" && (
                        <SourceTab updateFacebookLikeButtonTabData={updateFacebookLikeButtonTabData} facebookLikeButtonTabData={facebookLikeButtonTabData} />
                    )}
                    {activeSection === "Layout" && (
                        <LayoutTab updateFacebookLikeButtonTabData={updateFacebookLikeButtonTabData} facebookLikeButtonTabData={facebookLikeButtonTabData} />
                    )}
                </div>
            </div>
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/facebook-like-button"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link> </h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/facebook-like-button/facebook-like-button.svg`} alt="facebook-like-button"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/facebook-like-button/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/facebook-like-button" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Facebook Like Button <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Blank_Temp" && (
                      <BlankTemplateWidget facebookLikeButtonTabData={facebookLikeButtonTabData} />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 